module.exports = __webpack_public_path__ + "img/qi_live.e352dd08.jpg";